import './contributors.css'
import silhouettesImg from '../../../../assets/img/libro/bookOverview.jpg'
import audioFile from "../../../../assets/audios/puchero.mp3"

import { useRef, useState } from 'react'

const Contributors = () => {
  const audioRef = useRef(null)
  const [isPlaying, setIsPlaying] = useState(false)
  const [progress, setProgress] = useState(0)

  const toggleAudio = () => {
    if (!audioRef.current) return

    if (isPlaying) {
      audioRef.current.pause()
    } else {
      audioRef.current.play()
    }

    setIsPlaying(!isPlaying)
  }

  const handleTimeUpdate = () => {
    const audio = audioRef.current
    if (!audio) return

    const percentage = (audio.currentTime / audio.duration) * 100
    setProgress(percentage)
  }

  const handleSeek = (e) => {
    const audio = audioRef.current
    if (!audio) return

    const rect = e.currentTarget.getBoundingClientRect()
    const clickPosition = e.clientX - rect.left
    const percentage = clickPosition / rect.width
    audio.currentTime = percentage * audio.duration
  }

  return (
    <section className="contributors">
      {/* Fondo con siluetas */}
      <div
        className="contributors__background"
        style={{ backgroundImage: `url(${silhouettesImg})` }}
      />

      <div className="contributors__container section__padding">
        <h2 className="contributors__title">
          Conoce a las autoras de esta obra colectiva
        </h2>

       

        <div className="contributors__grid">

          {/* COLUMNA 1 */}
          <div className="contributors__column">
            <p><strong>Carolina Ackermann Barreiro</strong> (Uruguay – Estado español), investigadora, educadora, docente, activista y consultora en cultura menstrual y menopausia.</p>

            <p><strong>Mireia Pérez-Sabadell</strong> (Estado español), investigadora especializada en comunicación y representación mediática de la menstruación.</p>

            <p><strong>Amanda María López Cobo</strong> (Estado español), educadora menstrual especializada en Educación Sexual Integral y proyectos sociocomunitarios.</p>

            <p><strong>Emilia Almanza Towgood</strong> (México), educadora menstrual mexicana y consejera en salud menstrual, colaboradora en proyectos de UNICEF.</p>

            <p><strong>Sofía Cifuentes Contador</strong> (Chile – Estados Unidos), socióloga e investigadora del movimiento menstrual en América Latina.</p>

            <p><strong>Lorenza Urbani Lunetta</strong> (Italia – Argentina), educadora menstrual, investigadora y facilitadora lúdica en pedagogía cíclica.</p>

            <p><strong>Ma. Victoria López Benítez</strong> (Estado español), Doctora en Educación, docente y educadora menstrual. Codirectora del Curso Superior Universitario en Educación Menstrual (UB).</p>

            <p><strong>Nora Pascual Armendáriz</strong> (Estado español), educadora menstrual y profesora, especializada en pobreza menstrual y derechos menstruales.</p>

            <p><strong>Enara Iruretagoiena Domínguez</strong> (Estado español), investigadora de lo cíclico y educadora en economía feminista y ecofeminismo.</p>

            <p><strong>Núria Beitia Hernández</strong> (Estado español), psicóloga y educadora menstrual especializada en salud sexual y cultura menstrual.</p>

            <p><strong>Rut Anastasia Molina i Noguera</strong> (Estado español), docente y acompañante en salud integral, ciclicidad y mujer rural.</p>

            <p><strong>María Escalona Ponce</strong> (Estado español), educadora social y activista menstrual especializada en derechos humanos y educación menstrual inclusiva.</p>

            <p><strong>Carmen de la Borbolla Triano</strong> (Estado español), educadora menstrual y facilitadora emocional especializada en rituales de paso.</p>

            <p><strong>Agnès Font Ribas</strong> (Estado español), educadora social y educadora menstrual, creadora de proyectos comunitarios de educación cíclica.</p>
          </div>

        </div>

                   {/* AUDIO */}
          <div className="contributors__audio">
            <p>🔊 Escucha el audio donde Carolina narra cómo se gestó este proceso único de redacción colectiva, contado a través de la metáfora del “puchero”.</p>

            <button 
              className="contributors__audio-button"
              onClick={toggleAudio}
            >
              {isPlaying ? "Pausar audio" : "Escuchar audio"}
            </button>

            <div 
              className="contributors__progress"
              onClick={handleSeek}
            >
              <div 
                className="contributors__progress-bar"
                style={{ width: `${progress}%` }}
              />
            </div>

            <audio
              ref={audioRef}
              src={audioFile}
              onTimeUpdate={handleTimeUpdate}
              onEnded={() => {
                setIsPlaying(false)
                setProgress(0)
              }}
            />

          </div>
      </div>
    </section>
  )
}

export default Contributors
